<template lang='pug'>
  div.rating-container(v-if='product && product.attributes')
    template(v-if='$route.path.indexOf("reviews") !== -1')
      div.product-rating
        .product-rating-count(v-text='`${$t("products.reviews.title")} (${reviewsCount})`')
        product-rating-stars(:rating='reviewRating')

    template(v-else)
      template(v-if='isMobile')
        router-link.product-rating-link.btn.btn-block.btn-white(:to='{ name: "products-show-reviews", params: { id: product.attributes["slug-url"] } }')
          product-rating-stars(:rating='reviewRating')
          p.product-rating-count(v-text='reviewsCountText')

      template(v-else)
        template(v-if='shouldScrollToReviews')
          a.product-rating-link(href='#product-review-summary' @click='scrollToReviews')
            product-rating-stars(:rating='reviewRating')
            p.product-rating-count(v-text='reviewsCountText')
        template(v-else)
          router-link.product-rating-link(
            :to='{ name: "products-show", params: { id: product.attributes["slug-url"] }, hash: "#reviews" }'
            :target='openLinkInNewTab ? "_blank" : undefined'
            :rel='openLinkInNewTab ? "noopener" : undefined'
          )
            product-rating-stars(:rating='reviewRating')
            p.product-rating-count(v-text='reviewsCountText')
</template>

<script>
import ProductRatingStars from './product-rating-stars.vue'

export default {

  components: {
    ProductRatingStars
  },

  props: {
    product: {
      type: Object
    },
    reviewsCount: {
      type: Number,
      default: 0
    },
    shouldScrollToReviews: {
      type: Boolean,
      default: true
    },
    openLinkInNewTab: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    reviewRating () {
      return this.product.attributes['rating']
    },
    isMobile: () => vueSupport.isMobile,
    reviewsCountText () {
      return `${this.reviewsCount} ${this.$t('products.reviews.title')}`
    }
  },

  methods: {
    scrollToReviews () {
      this.$store.commit('setRenderBelowTheFold', true)
      this.$nextTick(() => {
        this.$scrollTo('#product-review-summary', 300, {
          offset: -20
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
  .rating-container {
    display: block;
    margin-top: 10px;
    margin-bottom: 10px;
    text-align: center;

    @include media-breakpoint-up(sm) {
      margin-top: 0;
      margin-bottom: 0;
      text-align: left;
    }

    &:hover {
      color: inherit;
    }

    .product-rating-count {
      @include font-weight-bold;
      display: inline-block;
      margin-right: 10px;
      margin-left: 8px;
      text-transform: uppercase;
      vertical-align: middle;

      @include media-breakpoint-up(md) {
        margin-right: 5px;
        vertical-align: initial;
      }
    }
  }

  .product-rating-link {
    .product-rating-count {
      font-size: 14px;
    }

    .product-rating-rating {
      margin-top: 0;
    }
  }

  .product-rating {
    padding-top: 5px;
    padding-bottom: 5px;

    .product-rating-count {
      font-size: 16px;
    }
  }

  .product-reviews-and-questions {
    .product-rating-rating {
      margin-top: 1px;
    }

    .product-rating-count {
      font-size: 16px;
      line-height: 18px;
      margin-top: 0;
    }

    .product-rating {
      &:hover {
        color: inherit;
      }
    }
  }
</style>

<style lang='scss'>
.rating-container .product-rating-count {
  @include media-breakpoint-up(md) {
    margin-bottom: 47px;
  }

  @include media-breakpoint-up(lg) {
    margin-bottom: 35px;
  }
}
</style>
